import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Logo, Btn, Input } from '../../components/UI';
import { useAuth } from '../../context/AuthContext';
import api from '../../utils/api';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault(); setError(''); setLoading(true);
    try {
      const { data } = await api.post('/api/auth/login', { email, password, device: navigator.userAgent });
      if (data.success) { login(data.token, data.user); navigate('/dashboard'); }
      else setError(data.message);
    } catch (err) { setError(err.response?.data?.message || 'Connection error'); }
    finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '80px 24px 40px' }}>
      <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 16, padding: 48, width: '100%', maxWidth: 420 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 24 }}><Logo size={44} /></div>
          <h1 style={{ fontSize: 22, fontFamily: 'Sora', fontWeight: 700, marginBottom: 8 }}>Welcome Back</h1>
          <p style={{ color: 'var(--text-muted)', fontSize: 14 }}>Sign in to your MS Reach account</p>
        </div>
        {error && <div style={{ background: 'rgba(255,68,68,0.1)', border: '1px solid rgba(255,68,68,0.3)', color: '#ff6b6b', padding: '12px 16px', borderRadius: 8, fontSize: 13, marginBottom: 16 }}>{error}</div>}
        <form onSubmit={handleSubmit}>
          <Input label="Email Address" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="your@email.com" required />
          <Input label="Password" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Enter your password" required />
          <div style={{ textAlign: 'right', marginBottom: 20, marginTop: -8 }}>
            <Link to="/forgot-password" style={{ fontSize: 13, color: 'var(--green)' }}>Forgot Password?</Link>
          </div>
          <Btn type="submit" disabled={loading} full size="lg">{loading ? 'Signing in...' : 'Sign In'}</Btn>
        </form>
        <div style={{ textAlign: 'center', marginTop: 20, fontSize: 13, color: 'var(--text-muted)' }}>
          Don't have an account? <Link to="/register" style={{ color: 'var(--green)' }}>Register here</Link>
        </div>
        <div style={{ textAlign: 'center', marginTop: 12 }}>
          <Link to="/admin/login" style={{ fontSize: 12, color: 'var(--text-muted)' }}>🔐 Admin Login</Link>
        </div>
      </div>
    </div>
  );
}
